@if (component) {
<div class="w-12 flex flex-column flex-justify-center flex-middle center bg-col-1 col-w p-t-10 p-a-4-s p-a-4-m p-t-5-s p-t-5-m p-b-10 p-b-5-s p-b-5-m"
     [style.min-width]="['304px', '286px', '278px', '278px'][client.sizeId]">
    <h3 class="h2"
        *iCms="'title' of component"></h3>
    <h3 class="m-t"
        [sizeClass]="'XL: p1, SM: p2'"
        [style.max-width]="['100%', '100%', '539px', '647px'][client.sizeId]"
        *iCms="'subtitle' of component; skipEmpty: true, content: 'html'"></h3>
    <newsletter-form class="block w-12 m-t"
                     [style.max-width]="['100%', '100%', '522px', '624px'][client.sizeId]"
                     [source]="component.source"
                     [successMessage]="component.successMessage"
                     [buttonCopy]="component.buttonCopy"></newsletter-form>
    <h3 class="c1 m-t text"
        *iCms="'bottomCopy' of component; skipEmpty: true, content: 'html'"></h3>
</div>
}